import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import {
  Stack,
  Icon,
  Tooltip,
  Text,
} from '@piwikpro/ui-components';

export interface FeatureListEntry {
  title: string
  tooltip?: string
}

const CORE_FEATURE_LIST: FeatureListEntry[] = [
  {
    title: 'marketing.change-plan-overlay.core-plan.point0-title',
    tooltip: 'marketing.change-plan-overlay.core-plan.point0-tooltip',
  },
  {
    title: 'marketing.change-plan-overlay.core-plan.point1-title',
    tooltip: 'marketing.change-plan-overlay.core-plan.point1-tooltip',
  },
  {
    title: 'marketing.change-plan-overlay.core-plan.point2-title',
  }, {
    title: 'marketing.change-plan-overlay.core-plan.point3-title',
  }, {
    title: 'marketing.change-plan-overlay.core-plan.point4-title',
  }, {
    title: 'marketing.change-plan-overlay.core-plan.point5-title',
  },
];
const ENTERPRISE_FEATURE_LIST: FeatureListEntry[] = [
  {
    title: 'marketing.change-plan-overlay.enterprise-plan.point0-title',
  },
  {
    title: 'marketing.change-plan-overlay.enterprise-plan.point1-title',
  },
  {
    title: 'marketing.change-plan-overlay.enterprise-plan.point2-title',
  }, {
    title: 'marketing.change-plan-overlay.enterprise-plan.point3-title',
  }, {
    title: 'marketing.change-plan-overlay.enterprise-plan.point4-title',
  },
  {
    title: 'marketing.change-plan-overlay.enterprise-plan.point5-title',
  },
  {
    title: 'marketing.change-plan-overlay.enterprise-plan.point6-title',
    tooltip: 'marketing.change-plan-overlay.enterprise-plan.point6-tooltip',
  },
];


// TODO: what about licensing 2.0?
const FeatureList: React.FunctionComponent<{
  variant: 'core' | 'enterprise'
  t: TFunction
}> = ({ variant, t }) => {
  const data = variant === 'enterprise' ? ENTERPRISE_FEATURE_LIST : CORE_FEATURE_LIST;

  return (
    <Stack vertical>
      {data.map(
        ({ title, tooltip }) => (
          <Stack.Item key={title}>
            <Stack>
              <Stack.Item>
                <Icon color="green" name="checkmark-circle-outline" />
              </Stack.Item>
              <Stack.Item fill>
                <Text as="p">
                  {t(title)}
                  {tooltip && (
                    <Tooltip content={t(tooltip)}>
                      <span style={{
                        marginLeft: '4px',

                      }}
                      >
                        <Icon display="inline" size="small" name="info-circle-outline" />
                      </span>
                    </Tooltip>
                  )}
                </Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        ),
      )}
    </Stack>
  );
};

export default withTranslation('administration')(FeatureList as any);
